import { Spin } from 'antd';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { axiosInstance, config } from '../pages/config';
import secureLocalStorage from 'react-secure-storage';

const PaymentSuccess = () => {
    const [loading, setLoading] = useState(false);
    const [payment_data, setPaymentData] = useState(null);

    const { pay_status } = useParams()
    const navigate = useNavigate()

    const possible_status = ['success', 'failed'];

    const queryParams = new URLSearchParams(window.location.search);
    const session_id = queryParams.get("session_id");

    useEffect(() => {
        if (!possible_status.includes(pay_status)) {
            navigate(config.appUrl)
        }
    }, [])

    useEffect(() => {
        async function getPaymentDetails() {
            try {
                setLoading(true)

                const response = await axiosInstance.post("/enrollment/details", { session_id })
                if (response.data.data) {
                    setPaymentData({
                        ...response.data.data,
                        amount: `£ ${response.data.data?.amount}`
                    } || {})
                    secureLocalStorage.removeItem('temp_details')
                } else {
                    navigate(`${config.appUrl}payment/failed`)
                }
            } catch (error) {
                console.log(error)
                navigate(`${config.appUrl}payment/failed`)

            } finally {
                setLoading(false)
            }
        }

        if (session_id)
            getPaymentDetails()

    }, [session_id])

    return (
        <div>
            <div className="ps-page--single">
                <div className="ps-section--custom pb-5">
                    <div className="d-flex justify-content-center">
                        <div className="col-7 ">
                            {loading === false ? (
                                <div className="text-center">

                                    {
                                        pay_status === 'success' ?
                                            <>

                                                <h2 className='mt-4' >  Hurrah, Payment Succeed! <i className='bi bi-check-circle-fill text-success'></i> </h2>
                                                <p className="text-black my-3">
                                                    Thank you for your interest! Your driving lessons have been successfully booked and are now being processed. You will receive a confirmation email shortly with the details of your lessons
                                                </p>

                                                <div className=' mt-4 mb-5'>
                                                    {
                                                        payment_data &&
                                                        <>
                                                            <h5 className='mb-4'>Payment Details</h5>
                                                            <table className='table text-start'>
                                                                <tbody>
                                                                    {
                                                                        Object.keys(payment_data).map(key => {
                                                                            return <tr>
                                                                                <th className='border-end text-capitalize'>
                                                                                    {key.split('_').join(' ')}</th>
                                                                                <td className='text-capitalize'>{payment_data[key]}</td>
                                                                            </tr>
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </>
                                                    }
                                                </div>

                                                <div className='mt-4'>
                                                    <Link to={`${config.appUrl}`} className="theme-btn btn-one text-white bg-dark me-3">Back to Home</Link>

                                                    <a href={config.StudentUrl} target='_blank' className="theme-btn btn-one text-white">
                                                        Go to dashboard
                                                    </a>
                                                </div>
                                            </> :

                                            <>
                                                <img
                                                    src="https://img.freepik.com/premium-vector/vector-illustration-about-concept-payment-error-nfc-non-cash-payment-transaction-cancelled_675567-3919.jpg?w=740"
                                                    alt="No img"
                                                    width="550"
                                                    className="margin-auto"
                                                />

                                                <h2 >Oops, Payment failed! <i className='bi bi-x-circle-fill text-danger'></i>  </h2>
                                                <p className="text-black my-3">
                                                    We're sorry, but your payment could not be processed at this time. Please try again or use a different payment method. If you need assistance, feel free to contact our support team.
                                                </p>

                                                <div>
                                                    <Link to={`${config.appUrl}`} className="theme-btn btn-one text-white me-3">
                                                        Back to Home
                                                    </Link>

                                                    <a href={config.StudentUrl} target='_blank' className="theme-btn btn-one text-white">
                                                        Go to dashboard
                                                    </a>
                                                </div>
                                            </>
                                    }



                                </div>
                            ) : (
                                <div className="mt-5 mb-5 text-center">
                                    <div className="mt-3 mb-3">
                                        <Spin />
                                    </div>
                                    <h3>Wait a moment</h3>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentSuccess